import React from 'react';
import { string } from 'prop-types';
import Loading from '../../atoms/Loading/index';
import SingleContentLayout from '../../templates/SingleContentLayout';
import UserPageLayout from '../../templates/UserPageLayout';
import User from '../../organisms/User';

import {USER} from '../../../constants';

const ProfilePage = ({fetchingState,...props}) => {
	// searching......
	if( fetchingState===USER.FETCHING){
		return<SingleContentLayout render={()=><Loading/>} />;
	}
	return <UserPageLayout 
		render={()=><User {...props}/>}
	/>;
};

ProfilePage.propTypes = {
	fetchingState:string.isRequired,
};

export default ProfilePage;